
//------------------------------------------------------------------------------
// <auto-generated>
//     This code was generated from a template (Model.tst).
//
//     Manual changes to this file may cause unexpected behavior in your application.
//     Manual changes to this file will be overwritten if the code is regenerated.
// </auto-generated>
//------------------------------------------------------------------------------

import { Model, ModelProperty } from 'models/Model';


export class NewOrderRequestModel extends Model<NewOrderRequestModel> {
	public static classProperties: ModelProperty[] = [
		
		{ name: 'seller', type: 'SellerDtoModel', languageString: 'newOrderRequest.property.seller', isHidden: true, isObject: true, new: () => { return new SellerDtoModel }, properties: () => { return SellerDtoModel.classProperties } },
		{ name: 'company', type: 'CompanyDtoModel', languageString: 'newOrderRequest.property.company', isHidden: true, isObject: true, new: () => { return new CompanyDtoModel }, properties: () => { return CompanyDtoModel.classProperties } },
		{ name: 'contact', type: 'ContactDtoModel', languageString: 'newOrderRequest.property.contact', isHidden: true, isObject: true, new: () => { return new ContactDtoModel }, properties: () => { return ContactDtoModel.classProperties } },
		{ name: 'products', type: 'ProductDtoModel[]', languageString: 'newOrderRequest.property.products', isHidden: true, isArray: true, isObject: true, new: () => { return new ProductDtoModel }, properties: () => { return ProductDtoModel.classProperties } },
		{ name: 'productPlanDiscontinuations', type: 'ProductPlanDiscontinuationDtoModel[]', languageString: 'newOrderRequest.property.productPlanDiscontinuations', isHidden: true, isArray: true, isObject: true, new: () => { return new ProductPlanDiscontinuationDtoModel }, properties: () => { return ProductPlanDiscontinuationDtoModel.classProperties } },
		{ name: 'signDate', type: 'Date', languageString: 'newOrderRequest.property.signDate' },
		{ name: 'agreementId', type: 'guid', languageString: 'newOrderRequest.property.agreementId' },
		{ name: 'replies', type: 'ReplyDtoModel[]', languageString: 'newOrderRequest.property.replies', isHidden: true, isArray: true, isObject: true, new: () => { return new ReplyDtoModel }, properties: () => { return ReplyDtoModel.classProperties } }
	];
	[key: string]: any;
	
	public seller?: SellerDtoModel;
	public company?: CompanyDtoModel;
	public contact?: ContactDtoModel;
	public products: ProductDtoModel[];
	public productPlanDiscontinuations: ProductPlanDiscontinuationDtoModel[];
	public signDate?: Date;
	public agreementId?: string;
	public replies: ReplyDtoModel[];
    
	constructor(){
		super();
		this.seller = undefined;
		this.company = undefined;
		this.contact = undefined;
		this.products = [];
		this.productPlanDiscontinuations = [];
		this.signDate = undefined;
		this.agreementId = undefined;
		this.replies = [];
		
	}
	getProperties(){
		return NewOrderRequestModel.classProperties;
	}
}
export class SellerDtoModel extends Model<SellerDtoModel> {
	public static classProperties: ModelProperty[] = [
		
		{ name: 'gormUserId', type: 'guid', languageString: 'sellerDto.property.gormUserId' },
		{ name: 'gormSalesTeamId', type: 'guid', languageString: 'sellerDto.property.gormSalesTeamId' }
	];
	[key: string]: any;
	
	public gormUserId?: string;
	public gormSalesTeamId?: string;
    
	constructor(){
		super();
		this.gormUserId = undefined;
		this.gormSalesTeamId = undefined;
		
	}
	getProperties(){
		return SellerDtoModel.classProperties;
	}
}
export class CompanyDtoModel extends Model<CompanyDtoModel> {
	public static classProperties: ModelProperty[] = [
		
		{ name: 'vatNumber', type: 'string', languageString: 'companyDto.property.vatNumber' },
		{ name: 'name', type: 'string', languageString: 'companyDto.property.name' },
		{ name: 'address', type: 'string', languageString: 'companyDto.property.address' },
		{ name: 'zipcode', type: 'string', languageString: 'companyDto.property.zipcode' },
		{ name: 'city', type: 'string', languageString: 'companyDto.property.city' },
		{ name: 'countryCode', type: 'string', languageString: 'companyDto.property.countryCode' },
		{ name: 'replies', type: 'ReplyDtoModel[]', languageString: 'companyDto.property.replies', isHidden: true, isArray: true, isObject: true, new: () => { return new ReplyDtoModel }, properties: () => { return ReplyDtoModel.classProperties } }
	];
	[key: string]: any;
	
	public vatNumber: string;
	public name: string;
	public address: string;
	public zipcode: string;
	public city: string;
	public countryCode: string;
	public replies: ReplyDtoModel[];
    
	constructor(){
		super();
		this.vatNumber = '';
		this.name = '';
		this.address = '';
		this.zipcode = '';
		this.city = '';
		this.countryCode = '';
		this.replies = [];
		
	}
	getProperties(){
		return CompanyDtoModel.classProperties;
	}
}
export class ContactDtoModel extends Model<ContactDtoModel> {
	public static classProperties: ModelProperty[] = [
		
		{ name: 'firstName', type: 'string', languageString: 'contactDto.property.firstName' },
		{ name: 'lastName', type: 'string', languageString: 'contactDto.property.lastName' },
		{ name: 'phone', type: 'string', languageString: 'contactDto.property.phone' },
		{ name: 'mobilePhone', type: 'string', languageString: 'contactDto.property.mobilePhone' },
		{ name: 'email', type: 'string', languageString: 'contactDto.property.email' }
	];
	[key: string]: any;
	
	public firstName: string;
	public lastName: string;
	public phone: string;
	public mobilePhone: string;
	public email: string;
    
	constructor(){
		super();
		this.firstName = '';
		this.lastName = '';
		this.phone = '';
		this.mobilePhone = '';
		this.email = '';
		
	}
	getProperties(){
		return ContactDtoModel.classProperties;
	}
}
export class ProductDtoModel extends Model<ProductDtoModel> {
	public static classProperties: ModelProperty[] = [
		
		{ name: 'unitPrice', type: 'number', languageString: 'productDto.property.unitPrice' },
		{ name: 'startupAmountInclFirstInvoice', type: 'number', languageString: 'productDto.property.startupAmountInclFirstInvoice' },
		{ name: 'startupAmountExclFirstInvoice', type: 'number', languageString: 'productDto.property.startupAmountExclFirstInvoice' },
		{ name: 'numberOfInstallments', type: 'number', languageString: 'productDto.property.numberOfInstallments' },
		{ name: 'startupInstallments', type: 'number', languageString: 'productDto.property.startupInstallments' },
		{ name: 'paymentInterval', type: 'number', languageString: 'productDto.property.paymentInterval' },
		{ name: 'productVariantId', type: 'guid', languageString: 'productDto.property.productVariantId' },
		{ name: 'generateInvoicesBasedOnProductPlanId', type: 'guid', languageString: 'productDto.property.generateInvoicesBasedOnProductPlanId' },
		{ name: 'childProducts', type: 'ProductDtoModel[]', languageString: 'productDto.property.childProducts', isHidden: true, isArray: true, isObject: true, new: () => { return new ProductDtoModel }, properties: () => { return ProductDtoModel.classProperties } },
		{ name: 'replies', type: 'ReplyDtoModel[]', languageString: 'productDto.property.replies', isHidden: true, isArray: true, isObject: true, new: () => { return new ReplyDtoModel }, properties: () => { return ReplyDtoModel.classProperties } }
	];
	[key: string]: any;
	
	public unitPrice: number;
	public startupAmountInclFirstInvoice?: number;
	public startupAmountExclFirstInvoice?: number;
	public numberOfInstallments?: number;
	public startupInstallments?: number;
	public paymentInterval: number;
	public productVariantId?: string;
	public generateInvoicesBasedOnProductPlanId?: string;
	public childProducts: ProductDtoModel[];
	public replies: ReplyDtoModel[];
    
	constructor(){
		super();
		this.unitPrice = 0;
		this.startupAmountInclFirstInvoice = undefined;
		this.startupAmountExclFirstInvoice = undefined;
		this.numberOfInstallments = undefined;
		this.startupInstallments = undefined;
		this.paymentInterval = 0;
		this.productVariantId = undefined;
		this.generateInvoicesBasedOnProductPlanId = undefined;
		this.childProducts = [];
		this.replies = [];
		
	}
	getProperties(){
		return ProductDtoModel.classProperties;
	}
}
export class ProductPlanDiscontinuationDtoModel extends Model<ProductPlanDiscontinuationDtoModel> {
	public static classProperties: ModelProperty[] = [
		
		{ name: 'productPlanId', type: 'guid', languageString: 'productPlanDiscontinuationDto.property.productPlanId' },
		{ name: 'adjustmentAmount', type: 'number', languageString: 'productPlanDiscontinuationDto.property.adjustmentAmount' },
		{ name: 'remainingAmount', type: 'number', languageString: 'productPlanDiscontinuationDto.property.remainingAmount' }
	];
	[key: string]: any;
	
	public productPlanId?: string;
	public adjustmentAmount: number;
	public remainingAmount: number;
    
	constructor(){
		super();
		this.productPlanId = undefined;
		this.adjustmentAmount = 0;
		this.remainingAmount = 0;
		
	}
	getProperties(){
		return ProductPlanDiscontinuationDtoModel.classProperties;
	}
}
export class ReplyDtoModel extends Model<ReplyDtoModel> {
	public static classProperties: ModelProperty[] = [
		
		{ name: 'questionId', type: 'guid', languageString: 'replyDto.property.questionId' },
		{ name: 'replyData', type: 'string', languageString: 'replyDto.property.replyData' }
	];
	[key: string]: any;
	
	public questionId?: string;
	public replyData: string;
    
	constructor(){
		super();
		this.questionId = undefined;
		this.replyData = '';
		
	}
	getProperties(){
		return ReplyDtoModel.classProperties;
	}
}

